import type { ColumnQualityApiResponse, QualityLevel } from '@/entities/quality';

export type ColumnQualityTableData = {
  key: string;
  fqn: string;
  tableName: string;
  columnName: string;
  dataZone: string;
  cumulativeRowCount: number;
  testType: string;
  incrementalRows: number;
  qualityStatus: {
    goodRows: number;
    goodRatio: number;
    poorRows: number;
    poorRatio: number;
    unknownRows: number;
    unknownRatio: number;
  };
  qualityEvaluationDate: string;
  qualityLevel: QualityLevel;
};

export const transformColumnApiDataToTableData = (apiData: ColumnQualityApiResponse): ColumnQualityTableData => {
  return {
    key: `${apiData.id}-${apiData.statDate}-${apiData.collectedAt}`,
    tableName: apiData.tableName,
    fqn: apiData.fqn,
    columnName: apiData.columnName,
    dataZone: apiData.dataZone,
    cumulativeRowCount: apiData.totalRows,
    incrementalRows: apiData.incrementalRows,
    testType: '결측치',
    qualityStatus: {
      goodRows: apiData.goodRows,
      goodRatio: apiData.goodRatio,
      poorRows: apiData.poorRows,
      poorRatio: apiData.poorRatio,
      unknownRows: apiData.unknownRows,
      unknownRatio: apiData.unknownRatio,
    },
    qualityLevel: apiData.qualityLevel,
    qualityEvaluationDate: apiData.collectedAt,
  };
};
